import { CircularProgress, Container } from "@mui/material";

import { useIsFeatureEntitled } from "../../../Context/TierProvider";
import { useCustomerHasAgentInstalled, useCustomerHasFsk8sPermissions } from "../hooks";
import Fsk8sUpsell from "./Fsk8sUpsell";

interface Fsk8sUpsellGuardProps {
  children: React.ReactNode;
}

const Fsk8sUpsellGuard = ({ children }: Fsk8sUpsellGuardProps) => {
  const { customerHasFsk8sPermissions, loading: permissionsLoading } = useCustomerHasFsk8sPermissions();
  const { customerHasAgentInstalled, loading: agentCheckLoading } = useCustomerHasAgentInstalled();
  const customerHasEntitlement = useIsFeatureEntitled("lens:k8s");

  if (agentCheckLoading || permissionsLoading) {
    return (
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "75vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (!customerHasEntitlement || !customerHasAgentInstalled || !customerHasFsk8sPermissions) {
    return <Fsk8sUpsell />;
  }

  return children;
};

export default Fsk8sUpsellGuard;
